module.exports = __webpack_public_path__ + "static/mule-f99c753f84033ff0b77160e739ae3965.png";